/** Ids del set propio de iconos de dominio (rejilla 24 px, trazo 1,75, remates redondos). */
export const DOMAIN_ICON_IDS = [
  'vaca',
  'bufalo',
  'cerdo',
  'leche',
  'queso',
  'hortaliza',
  'fruta',
  'billete',
  'pizarra',
  'balanza',
  'camion',
  'campana',
  'mercado',
] as const;

export type DomainIconId = (typeof DOMAIN_ICON_IDS)[number];

export const isDomainIconId = (value: string): value is DomainIconId =>
  (DOMAIN_ICON_IDS as readonly string[]).includes(value);
